import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import Zdog from 'zdog';

import { IBackgroundGrids, IBuildingTree, IPinScene, IPosition3d } from '../../models';
import { RootState } from '..';

type VisualizationSliceState = {
  axisOffset: IPosition3d;
  backgroundGrids: IBackgroundGrids;
  buildingScene: Zdog.Anchor;
  buildingTree?: IBuildingTree;
  pinScenes: Array<IPinScene>;
  selectedPinInfo?: {
    floorId: number;
    zoneId: number;
  };
};

/**
 * Slice
 */
export const visualizationSlice = createSlice({
  name: 'visualizationSlice',
  initialState: {
    axisOffset: {
      x: 0,
      y: 0,
      z: 0,
    },
    backgroundGrids: {
      xy: new Zdog.Group(),
      yz: new Zdog.Group(),
      zx: new Zdog.Group(),
    },
    buildingScene: new Zdog.Anchor(),
    pinScenes: [],
  } as VisualizationSliceState,
  reducers: {
    updateVisualization: (state, action: PayloadAction<Partial<VisualizationSliceState>>) => {
      return { ...state, ...action.payload };
    },
  },
});

/**
 * Actions
 */
export const { updateVisualization } = visualizationSlice.actions;

/**
 * Selectors
 */
export const selectVisualizationSlice = (state: RootState) => state.visualizationSlice;
export const selectVisualizationSliceInfo = createSelector([selectVisualizationSlice], (visualizationSlice) => {
  const { axisOffset, backgroundGrids, buildingScene, buildingTree, pinScenes, selectedPinInfo } = visualizationSlice;
  const floors = buildingTree?.floors;
  const isHoveredPin = !!selectedPinInfo;

  return {
    axisOffset,
    backgroundGrids,
    buildingScene,
    buildingTree,
    pinScenes,
    selectedPinInfo,
    floors,
    isHoveredPin,
  };
});
